import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';

export interface TitleProps extends PropsWithChildren {
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        text: {
            fontSize: 16,
            lineHeight: '16px',
            fontWeight: 600,
            color: '#000000'
        }
    })
);

export const Title: FunctionComponent<TitleProps> = props => {
    const classes = useStyles(props);

    return <Typography className={clsx(classes.text, props.className)}>{props.children}</Typography>;
};

export default Title;
